import styled from 'styled-components';

export const Container = styled.section`
  display: grid;
  justify-content: center;
  align-content: center;
  padding-top: 3rem;
  @media only screen and (min-width: 90em) {
    padding: 6rem 3rem;
  }
`;
